export default {
      id: "EUR-usage",
      viewBox: "0 0 382 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#EUR",
      toString: function () {
        return this.url;
      }
    }